import { colors } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

import {
  ConfigureDestinationsModal,
  KeyValueMappingControl,
} from "../../modals/ConfigureDestinationsModal";

import { DestinationConfigRow } from "../shared/ConfigPageRow";

const CredentialsModal = ({ destination, open, onClose }) => {
  const googlePubSub = useSelector(
    (state) => state.destinations.data["google-pubsub"]
  );
  const { settings: allSettings } = googlePubSub;

  return (
    <ConfigureDestinationsModal
      limitSettings={[]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
    />
  );
};

const CredentialsRow = ({ setConfigModalOpen }) => {
  return (
    <DestinationConfigRow
      name="Credentials"
      labelColor={colors.grey[600]}
      labelText={"Instructions"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
}) => {
  const allSettings = useSelector(
    (state) => state.destinations.data["google-pubsub"].settings
  );

  return (
    <ConfigureDestinationsModal
      settingsToControl={{
        eventTopicMappings: (props) => (
          <KeyValueMappingControl
            keyLabel="Event Name"
            valueLabel="Topic Name"
            objectLabel="Mapping"
            {...props}
          />
        ),
      }}
      limitSettings={["eventTopicMappings"]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen }) => {
  return (
    <DestinationConfigRow
      name="Mappings"
      labelColor={colors.grey[400]}
      labelText={"Mappings"}
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const OPTIONS = "OPTIONS";

const Rows = {
  CREDENTIALS: CredentialsRow,
  OPTIONS: ConfigurationRow,
};

const Modals = {
  CREDENTIALS: CredentialsModal,
  OPTIONS: ConfigurationModal,
};

const RowOrder = [CREDENTIALS, OPTIONS];

export default {
  Rows,
  RowOrder,
  Modals,
};
